<template>
  <FormBuilder />
</template>

<script>
import FormBuilder from '../../components/categories/formBuilder/index.vue'
export default {
  components: {
    FormBuilder,
  },
}
</script>
